export default __webpack_public_path__ + "static/media/cart.064272a9.svg";